(function($){

	// Ajax
	function ajaxCall(url, targetElement){
		$(targetElement).addClass('loading');
		$.ajax({
			'url': url,
			'success': function(response)
			{
				//console.log($(response).find(target));
				$(targetElement).replaceWith($(response).find(targetElement));
				$(targetElement).removeClass('loading');
				document.getElementById($(targetElement).attr("id")).scrollIntoView({behavior: "smooth"});
				window.history.pushState(null,null,url);
			},
			'error': function(jqXHR, textStatus, errorThrown)
			{
				//console.log('Error on saving appointment:', jqXHR, textStatus, errorThrown);
				$(targetElement).removeClass('loading');
			}
		});
	}

	// Ajax links
	$('#page-wrapper').on("click", "a[data-target]", function(e){
		e.preventDefault();
		var target = $(this).data('target');
		var url =  $(this).attr("href");
		//console.log(url);
		ajaxCall(url, target);
	});
	// Ajax pagination
	$('#page-wrapper').on('click', ".pagination[data-target] a", function(e){
		e.preventDefault();
		var target = $(this).parents('.pagination').data('target');
		var url =  $(this).attr("href");
		//console.log(target);
		ajaxCall(url, target);
	});


	$(".navbar-toggler").click(function(){
		$(".navbar__mobile").toggleClass("show");
	});

	$(".section table").addClass("table").wrap("<div class='table-responsive'></div>");
	$(".section table").addClass("table").wrap("<div class='table-responsive'></div>");

	// Scrolltop button
	/*
	$('#btn-up').click(function(e){
		e.preventDefault();
		$('body,html').animate({scrollTop:0}, 500);
	});
	$(window).scroll(function () {
		if ($(window).scrollTop() > 301) {
			$('#btn-up').removeClass('disabled');
		}
		if ($(window).scrollTop() < 300) {
			$('#btn-up').addClass('disabled');
		}
	});
	*/

	$('.st-contacts--dropdown .st-contacts__items').each(function(){
		$(this).css('height', 'auto');
		$(this).data('height', $(this).height()).addClass('inited');
		$(this).css('height', 0);
	});
	$('.st-contacts--dropdown h2').click(function(){

		var dropdown = $(this).parents('.st-contacts--dropdown');
		var wasOpen = dropdown.hasClass('open');

		$('.st-contacts--dropdown').removeClass('open').find('.st-contacts__items').css('height', 0);

		if(wasOpen){
			dropdown.removeClass('open');
			dropdown.find('.st-contacts__items').css('height', 0);
		} else{
			dropdown.addClass('open');
			dropdown.find('.st-contacts__items').css('height', dropdown.find('.st-contacts__items').data('height'));
		}

	});

	var logosSwiper = new Swiper('.more-logos .swiper-container', {
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: '.more-logos .swiper-button-next',
			prevEl: '.more-logos .swiper-button-prev',
		},
		breakpoints: {
			// when window width is >= 320px
			400: { 
				slidesPerView: 2,
				spaceBetween: 15
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30
			},
			1640: {
				slidesPerView: 5,
				spaceBetween: 30
			}
		}
	});

	var swiper = new Swiper('.gallery', {
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: '.section--gallery .swiper-button-next',
			prevEl: '.section--gallery .swiper-button-prev',
		},
		breakpoints: {
			// when window width is >= 320px
			400: {
				slidesPerView: 2,
				spaceBetween: 15
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30
			},
			1640: {
				slidesPerView: 5,
				spaceBetween: 30
			}
		}
	});


	var galleryNav = new Swiper('.product__images-thumbs', {
		//slidesPerView: 'auto',
		spaceBetween: 30,
		slidesPerView: 3,
		loop: false,
		freeMode: true,
		centeredSlides: true,
		centeredSlidesBounds: true,
		loopedSlides: 5, //looped slides should be the same
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	var galleryMain = new Swiper('.product__images-main', {
		spaceBetween: 30,
		loop:false,
		loopedSlides: 5, //looped slides should be the same
		autoHeight: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		thumbs: {
			swiper: galleryNav
		}
	});

	galleryMain.on('slideChange', function () {
		galleryNav.slideTo(galleryMain.activeIndex);
	});


	// tabs + table wrap
	$('.tabs table').each(function(){
		$(this).wrap('<div class="table-responsive"></div>');
	});

	var tabsNav = new Swiper('.tabs__navigation', {
		spaceBetween: 10,
		slidesPerView: 'auto',
		loop: false,
		freeMode: true,
		loopedSlides: 5, //looped slides should be the same
		watchSlidesVisibility: true,
		watchSlidesProgress: true
	});

	var tabsContents = new Swiper('.tabs__contents', {
		spaceBetween: 40,
		allowTouchMove: false,
		loop:false,
		loopedSlides: 5, //looped slides should be the same
		autoHeight: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		thumbs: {
			swiper: tabsNav
		},
		hashNavigation: {
			replaceState: true,
			watchState: true
		}
	});
	tabsContents.on('slideChange', function () {
		tabsNav.slideTo(tabsContents.activeIndex);
	});


		// Photoswipe
		var initPhotoSwipeFromDOM = function(gallerySelector) {

			// parse slide data (url, title, size ...) from DOM elements
			// (children of gallerySelector)
			var parseThumbnailElements = function(el) {
				var thumbElements = el.childNodes,
					numNodes = thumbElements.length,
					items = [],
					figureEl,
					linkEl,
					size,
					item;
	
				for(var i = 0; i < numNodes; i++) {
	
					figureEl = thumbElements[i]; // <figure> element
	
					// include only element nodes
					if(figureEl.nodeType !== 1) {
						continue;
					}
	
					linkEl = figureEl.children[0]; // <a> element
	
					size = linkEl.getAttribute('data-size').split('x');

					// create slide object
					item = {
						src: linkEl.getAttribute('href'),
						w: parseInt(size[0], 10),
						h: parseInt(size[1], 10)
					};
	
	
	
					if(figureEl.children.length > 1) {
						// <figcaption> content
						item.title = figureEl.children[1].innerHTML;
					}
	
					if(linkEl.children.length > 0) {
						// <img> thumbnail element, retrieving thumbnail url
						item.msrc = linkEl.querySelectorAll('.image-item__img')[0].getAttribute('src');
					}
	
					item.el = figureEl; // save link to element for getThumbBoundsFn
					items.push(item);
				}
	
				return items;
			};
	
			// find nearest parent element
			var closest = function closest(el, fn) {
				return el && ( fn(el) ? el : closest(el.parentNode, fn) );
			};
	
			// triggers when user clicks on thumbnail
			var onThumbnailsClick = function(e) {
				e = e || window.event;
				e.preventDefault ? e.preventDefault() : e.returnValue = false;
	
				var eTarget = e.target || e.srcElement;
	
				// find root element of slide
				var clickedListItem = closest(eTarget, function(el) {
					return (el.tagName && el.tagName.toUpperCase() === 'DIV');
				});
	
				if(!clickedListItem) {
					return;
				}
	
				// find index of clicked item by looping through all child nodes
				// alternatively, you may define index via data- attribute
				var clickedGallery = clickedListItem.parentNode,
					childNodes = clickedListItem.parentNode.childNodes,
					numChildNodes = childNodes.length,
					nodeIndex = 0,
					index;
	
				for (var i = 0; i < numChildNodes; i++) {
					if(childNodes[i].nodeType !== 1) {
						continue;
					}
	
					if(childNodes[i] === clickedListItem) {
						index = nodeIndex;
						break;
					}
					nodeIndex++;
				}
	
	
	
				if(index >= 0) {
					// open PhotoSwipe if valid index found
					console.log(index);
					console.log(clickedGallery);

					openPhotoSwipe( index, clickedGallery );
				}
				return false;
			};
	
			// parse picture index and gallery index from URL (#&pid=1&gid=2)
			/*
			var photoswipeParseHash = function() {
				var hash = window.location.hash.substring(1),
					params = {};
	
				if(hash.length < 5) {
					return params;
				}
	
				var vars = hash.split('&');
				for (var i = 0; i < vars.length; i++) {
					if(!vars[i]) {
						continue;
					}
					var pair = vars[i].split('=');
					if(pair.length < 2) {
						continue;
					}
					params[pair[0]] = pair[1];
				}
	
				if(params.gid) {
					params.gid = parseInt(params.gid, 10);
				}
	
				return params;
			};
	*/
			var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
				var pswpElement = document.querySelectorAll('.pswp')[0],
					gallery,
					options,
					items;
	
				items = parseThumbnailElements(galleryElement);
	
				// define options (if needed)
				options = {
					galleryUID: galleryElement.getAttribute('data-pswp-uid'),
					getThumbBoundsFn: function(index) {
						// See Options -> getThumbBoundsFn section of documentation for more info
						var thumbnail = items[index].el.querySelectorAll('.image-item__img')[0], // find thumbnail
							pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
							rect = thumbnail.getBoundingClientRect();
	
						return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
					},
					showHideOpacity:true
				};
	
				// PhotoSwipe opened from URL
				if(fromURL) {
					if(options.galleryPIDs) {
						// parse real index when custom PIDs are used
						// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
						for(var j = 0; j < items.length; j++) {
							if(items[j].pid == index) {
								options.index = j;
								break;
							}
						}
					} else {
						// in URL indexes start from 1
						options.index = parseInt(index, 10) - 1;
					}
				} else {
					options.index = parseInt(index, 10);
				}
	
				// exit if index not found
				if( isNaN(options.index) ) {
					return;
				}
	
				if(disableAnimation) {
					options.showAnimationDuration = 0;
				}
	
				// Pass data to PhotoSwipe and initialize it
				gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
				gallery.init();
			};
	
			// loop through all gallery elements and bind events
			var galleryElements = document.querySelectorAll( gallerySelector );
	
			for(var i = 0, l = galleryElements.length; i < l; i++) {
				galleryElements[i].setAttribute('data-pswp-uid', i+1);
				galleryElements[i].onclick = onThumbnailsClick;
			}
	
			// Parse URL and open gallery if it contains #&pid=3&gid=1
/*
			var hashData = photoswipeParseHash();
			if(hashData.pid && hashData.gid) {
				openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
			}
*/
		};

	// execute above function
	$('a.swipebox').click(function(e){
		e.preventDefault();
	});
	initPhotoSwipeFromDOM('.product__images-main-inner');





})(jQuery);

